import {
  DataGrid,
  type DataGridProps,
  type GridValidRowModel,
  NoRowsOverlay,
} from '@shared/components';

type QContentListTableProps<TRowModel extends GridValidRowModel> = DataGridProps<TRowModel>;

export default function QContentListTable<TRowModel extends GridValidRowModel>(
  props: Readonly<QContentListTableProps<TRowModel>>,
) {
  return (
    <DataGrid
      slots={{ noRowsOverlay: NoRowsOverlay }}
      disableColumnMenu
      {...props}
      initialState={{
        sorting: {
          sortModel: [{ field: 'updatedAt', sort: 'desc' }],
        },
      }}
      sx={(theme) => ({
        backgroundColor: theme.palette.common.white,
        borderRadius: theme.shape.rounded(0),
        '.MuiDataGrid-cell': {
          padding: theme.spacing(3),
          paddingBottom: theme.spacing(2.75),
        },
        '.MuiDataGrid-columnHeader': {
          padding: theme.spacing(3),
        },
        '.MuiDataGrid-cell:last-child': {
          padding: theme.spacing(1.5),
        },
        '.MuiDataGrid-columnHeaders': {
          borderRadius: theme.shape.rounded(0),
        },
      })}
      getRowHeight={() => 48}
    />
  );
}
